import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProtectedData } from "../../../../redux/protectedDataSlice";
export function OwnerDashboard(props) {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.protectedData);

  useEffect(() => {
    // console.log("Fetching protected data...");
    dispatch(fetchProtectedData());
    // dispatch(fetchProtectedData())
    //   .unwrap()
    //   .then((data) => {
    //     console.log("API Response from fetch protected data thunk:", data);
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching protected Data:", error);
    //   });
    // dispatch(fetchProtectedData()); // Fetch data when component mounts
  }, [dispatch]);

  if (loading) return <p>Loading...</p>;
  // if (error) return <p>Error: {error}</p>;

  return (
    <>
      <p>
        This is the owner Dashboard..... Will include owner access and same
        options as admin, assitant admin, employees and users and employees,{" "}
      </p>
      <a href="https://www.google.com/">User Tuner</a>
      <hr />
      <div>
        <h1>Protected Data</h1>
        <pre>{JSON.stringify(data, null, 2)}</pre>
      </div>
    </>
  );
}
